import React from 'react';
import { Navigate } from 'react-router-dom';
import Login from '../pages/Login';

const publicRoutes = [
  { path: '/', element: <Login /> },
  { path: '*', element: <Navigate to="/" /> }
];

export default publicRoutes;
